/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Discount } from './Discount';
import {
    DiscountFromJSON,
    DiscountFromJSONTyped,
    DiscountToJSON,
} from './Discount';
import type { Money } from './Money';
import {
    MoneyFromJSON,
    MoneyFromJSONTyped,
    MoneyToJSON,
} from './Money';

/**
 * 
 * @export
 * @interface QuantityPrice
 */
export interface QuantityPrice {
    /**
     * 
     * @type {string}
     * @memberof QuantityPrice
     */
    id?: string;
    /**
     * 
     * @type {Money}
     * @memberof QuantityPrice
     */
    listPrice?: Money;
    /**
     * 
     * @type {Money}
     * @memberof QuantityPrice
     */
    salesPrice?: Money;
    /**
     * 
     * @type {Money}
     * @memberof QuantityPrice
     */
    vatAmount?: Money;
    /**
     * 
     * @type {number}
     * @memberof QuantityPrice
     */
    vatRate?: number;
    /**
     * 
     * @type {string}
     * @memberof QuantityPrice
     */
    currency?: string;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof QuantityPrice
     */
    discounts?: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof QuantityPrice
     */
    quantityPriceDescriptor?: string;
}

/**
 * Check if a given object implements the QuantityPrice interface.
 */
export function instanceOfQuantityPrice(value: object): boolean {
    return true;
}

export function QuantityPriceFromJSON(json: any): QuantityPrice {
    return QuantityPriceFromJSONTyped(json, false);
}

export function QuantityPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuantityPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'listPrice': json['listPrice'] == null ? undefined : MoneyFromJSON(json['listPrice']),
        'salesPrice': json['salesPrice'] == null ? undefined : MoneyFromJSON(json['salesPrice']),
        'vatAmount': json['vatAmount'] == null ? undefined : MoneyFromJSON(json['vatAmount']),
        'vatRate': json['vatRate'] == null ? undefined : json['vatRate'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(DiscountFromJSON)),
        'quantityPriceDescriptor': json['quantityPriceDescriptor'] == null ? undefined : json['quantityPriceDescriptor'],
    };
}

export function QuantityPriceToJSON(value?: QuantityPrice | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'listPrice': MoneyToJSON(value['listPrice']),
        'salesPrice': MoneyToJSON(value['salesPrice']),
        'vatAmount': MoneyToJSON(value['vatAmount']),
        'vatRate': value['vatRate'],
        'currency': value['currency'],
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(DiscountToJSON)),
        'quantityPriceDescriptor': value['quantityPriceDescriptor'],
    };
}

